exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .content form {\n  width: 100%;\n  max-width: 800px !important; }\n\n:host .content .form-errors-model {\n  -ms-flex: 1;\n      flex: 1; }\n  :host .content .form-errors-model code {\n    background: none !important; }\n\n.reply-dialog-button mat-icon {\n  color: #fff; }\n\n.mat-radio-button {\n  margin-right: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/create-corporate-user/create-corporate-user.component.scss
// module id = ../../../../../src/app/main/content/create-corporate-user/create-corporate-user.component.scss
// module chunks = main